
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slot-booking",
      function () {
        return require("private-next-pages/slot-booking/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slot-booking"])
      });
    }
  